export default {"src":"/_next/static/media/support.fb2ff0f9.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};